<template>
  <div class="share-story-container">
    <a-row class="share-story">
      <a-col :span="24">
        <a-spin :spinning="isWaiting" :tip="waitingPercentage > 0 ? `Compressing video ${waitingPercentage}% ...` : null" size="large">
          <div class="spin-content">
            <div class="challenge-logo" style="margin-bottom: 30px" v-if="theme == 'dark'">
              <img src="resources/images/challenge-resource/js_challenge_logo.png" alt="Truelife" style="width: 280px" />
              <div class="congrats-description" v-if="theme == 'dark' && type === 'story' && videoObject && videoObject.status === 'approved'">
                <h4 style="color: white; margin-top: 30px">
                  Congratulations you are ready to share your Jesus Story!
                  <br />
                  Now to complete the challenge use your link below to share on social media, email and text.
                  <br />
                  Thank you for making a HUGE impact!
                </h4>
              </div>
            </div>
            <a-card :title="cardTitle" class="style3 share-introvideo-title">
              <template #extra><a :href="`https://truelife.org/pages/contact-truelife-org?from=` + (isPastor ? 'pastor' : 'syjs')" target="_blank">Support Request</a></template>
              <!-- <p v-if="waitingPercentage > 0 || stage === 'upload'" class="text-warn">Do not leave this page or you will need to start over.</p> -->
              <transition name="fade">
                <StartOver v-if="stage == 'start'" :type="type" @onSelectVideoType="onSelectVideoType" key="start" />
                <ErrorMessage v-if="stage == 'error'" :error-message="errorMessage" key="error" />
                <PreviewVideo
                  v-if="stage == 'preview'"
                  :video-file="videoFile"
                  :type="type"
                  :language="language"
                  :video-slug="videoSlug"
                  @onRedo="onRedo"
                  @onExternalPreviewDone="onExternalPreviewDone"
                  key="preview"
                />
                <EmbedVideo v-if="stage == 'embed'" :type="type" :video-url="videoUrl" :video-slug="videoSlug" @onEmbedVideoDone="onEmbedVideoDone" @onRedo="onRedo" key="embed" />
                <SignVideo v-if="stage == 'sign'" @onSubmit="onSignComplete" key="sign" />
                <UploadVideo v-if="stage == 'upload'" :video-file="videoFile" @onComplete="onUploadComplete" @onFail="onUploadFail" key="upload" />
                <ReviewVideo v-if="stage == 'review'" :video-object="videoObject" :video-slug="videoSlug" :type="type" :language="language" @onRedo="onRedo" key="review" />
              </transition>
              <input type="file" style="width: 0; height: 0" accept="video/mp4,video/x-m4v,video/*" ref="videoPicker" @change="videoUploadChange" />
            </a-card>
          </div>
        </a-spin>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IntroVideoService from '@/services/IntroVideoService';
import Uploader from '@/services/UploadService';
import StartOver from './StartOver';
import ErrorMessage from './ErrorMessage';
import PreviewVideo from './PreviewVideo';
import EmbedVideo from './EmbedVideo';
import SignVideo from './SignVideo';
import UploadVideo from './UploadVideo';
import ReviewVideo from './ReviewVideo';
import store from '@/store';
export default {
  components: {
    ErrorMessage,
    StartOver,
    PreviewVideo,
    EmbedVideo,
    SignVideo,
    UploadVideo,
    ReviewVideo,
  },
  props: {
    type: {
      type: String,
      default: 'welcome',
    },
    language: {
      type: String,
      default: 'en',
    },
  },
  data: () => ({
    isCreate: true,
    isSaving: false,
    stage: 'loading',
    videoObject: null,
    errorMessage: null,
    videoType: null,
    videoFile: null,
    videoUrl: null,
    videoSlug: null,
    signImage: null,
    videoThumbnail: '',
    waitingPercentage: 0,
  }),
  computed: {
    ...mapGetters(['theme']),
    isWaiting() {
      return this.isLoading || this.isSaving;
    },
    isLoading() {
      return this.stage === 'loading';
    },
    cardTitle() {
      if (this.isCreate && this.stage === 'review') {
        return "Now it's time to connect your church!";
      } else if (this.isCreate && this.stage === 'sign') {
        return 'Confirmation!';
      } else if (this.type === 'welcome') {
        const langName = this.language === 'es' ? 'Spanish' : this.language === 'en' ? 'English' : this.language;
        return `Pastor Invitation Video Studio${langName ? ' - ' + langName : ''}`;
      } else if (this.type === 'story' && this.videoObject) {
        return 'My Jesus Story Studio';
      } else if (this.type === 'story') {
        return 'How do I share my story?';
      } else {
        return '';
      }
    },
  },
  methods: {
    openInstructionVideo(videoUrl) {},
    async fetchData() {
      try {
        this.videoObject = await IntroVideoService.fetch(this.type, this.language);
        if (this.videoObject) {
          this.videoSlug = this.videoObject.slug;
        }
        if (this.videoObject && this.videoObject.video_url !== '' && this.videoObject.video_thumbnail) {
          this.isCreate = false;
          this.changeStage('review');
        } else {
          this.isCreate = true;
          this.changeStage('start');
          // this.$router.push({ name: 'captureVideo', query: { redirectTo: 'shareYourStory' } });
        }
      } catch (err) {
        this.errorMessage = err.response.data.error || this.$t('label.somethingWentWrong');
        this.changeStage('error');
      }
    },
    onSelectVideoType(videoType) {
      if (videoType === 'file') {
        this.$refs.videoPicker.click();
      } else if (videoType === 'record') {
        sessionStorage.setItem(`share-your-story-slug-${this.language}`, this.videoSlug);
        sessionStorage.setItem('share-your-story-slug', this.videoSlug);
        sessionStorage.removeItem(`captured-consumed-${this.language}`);
        this.$router.push({ name: 'captureVideo', query: { redirectTo: this.type === 'welcome' ? 'welcomeVideo' : 'shareYourStory', lang: this.language } });
        // this.changeStage('record');
      } else if (videoType === 'embed') {
        this.changeStage('embed');
      }
    },
    async videoUploadChange(event) {
      if (this.$refs.videoPicker.files.length) {
        this.videoFile = this.$refs.videoPicker.files[0];

        if (!this.videoFile) {
          return;
        }

        this.videoType = 'external';
        this.changeStage('preview');
      }
    },
    onRecordVideoDone(videoBlob) {
      this.videoFile = new File([videoBlob], videoBlob.name, { type: videoBlob.type });
      this.videoType = 'external';
      this.changeStage('preview');
    },
    async onRedo() {
      if (this.videoObject && this.videoObject.id) {
        try {
          this.isSaving = true;
          this.resetAndGotoStart();
        } catch (err) {
          this.$notification['error']({
            message: err.response.data.error || this.$t('label.somethingWentWrong'),
          });
        } finally {
          this.isSaving = false;
        }
      } else {
        this.resetAndGotoStart();
      }
    },
    async onExternalPreviewDone(slug, thumbnail) {
      console.log('Validating slug... ', slug);
      const errorMessage = await this.tryUpdateSlug(slug);
      if (errorMessage) {
        this.$notification['error']({ message: errorMessage });
        return;
      }

      this.videoThumbnail = thumbnail;
      this.changeStage('upload');
    },
    async onEmbedVideoDone(slug, embedUrl, thumbnail) {
      const errorMessage = await this.tryUpdateSlug(slug);
      if (errorMessage) {
        this.$notification['error']({ message: errorMessage });
        return;
      }

      this.videoUrl = embedUrl;
      this.videoThumbnail = thumbnail;
      this.videoType = 'embed';
      this.changeStage('upload');
    },
    async onSignComplete(signature) {
      this.signImage = signature;

      if (this.videoType === 'external' && this.videoFile && !this.videoUrl) {
        this.changeStage('upload');
      } else {
        await this.saveIntroVideo(this.videoUrl);
      }
    },
    async onUploadComplete(videoUrl) {
      await this.saveIntroVideo(videoUrl);
    },
    onUploadFail(error) {
      this.$notification['error']({
        message: error || 'Upload failed!',
      });

      this.gotoPreview();
    },
    gotoPreview() {
      if (!this.isCreate) {
        return;
      }

      if (this.videoType === 'external') {
        this.stage = 'preview';
      } else if (this.videoType === 'embed') {
        this.stage = 'embed';
      }
    },
    resetAndGotoStart() {
      this.isCreate = true;
      this.videoObject = null;
      this.videoType = null;
      this.videoFile = null;
      this.videoUrl = null;
      this.signImage = null;
      this.changeStage('start');
      this.waitingPercentage = 0;
    },
    async saveIntroVideo(newUrl) {
      try {
        this.isSaving = true;

        if (this.videoThumbnail.includes('data:image')) {
          const resp = await new Uploader().uploadImage({
            contentType: 'image/png',
            fileName: `thumb_${Date.now()}.png`,
            file: this.videoThumbnail,
          });
          this.videoThumbnail = resp.Location;
        } else {
          this.videoThumbnail = null;
        }

        const videoObj = await IntroVideoService.create({
          intro_type: this.type,
          video_type: this.videoType,
          video_url: newUrl,
          video_thumbnail: this.videoThumbnail,
          slug: this.videoSlug,
          signature: this.signImage,
          language: this.language,
        });

        // We still use .mkv file because it's being in transcoding by Elastic Transcoder yet.
        if (this.videoFile) {
          videoObj.video_url = URL.createObjectURL(this.videoFile);
        }

        this.videoObject = videoObj;
        this.stage = 'review';
        store.dispatch('updateUser', {
          user: {
            ...store.state.user.user,
            story: videoObj,
          },
        });
      } catch (err) {
        this.$notification['error']({
          message: err.response.data.error || this.$t('label.somethingWentWrong'),
        });

        this.gotoPreview();
      } finally {
        this.isSaving = false;
      }
    },
    async tryUpdateSlug(slug) {
      if (this.videoSlug === slug) {
        return null;
      }

      try {
        this.isSaving = true;

        const isValid = await IntroVideoService.checkSlug(this.type, slug, this.language);
        if (!isValid) {
          return this.$t('label.slugExists');
        }

        this.videoSlug = slug;
      } catch (err) {
        return err.response.data.error || this.$t('label.somethingWentWrong');
      } finally {
        this.isSaving = false;
      }

      return null;
    },
    changeStage(stage) {
      this.stage = stage;
    },
  },
  created() {
    // this.$router.beforeEach((to, from, next) => {
    //   if (from.name !== to.name && from.name === 'shareYourStory' && ['loading', 'preview', 'upload', 'sign'].includes(this.stage)) {
    //     this.$confirm({
    //       title: 'Are you sure you want to leave this page?',
    //       onOk() {
    //         return next();
    //       },
    //       onCancel() {
    //         next(false);
    //       },
    //     });
    //   } else {
    //     return next();
    //   }
    // });

    const captured = this.$router.currentRoute.params.captured;
    const langParam = this.$router.currentRoute.params.lang;
    const alreadyConsumed = sessionStorage.getItem(`captured-consumed-${this.language}`);
    if (captured && (!langParam || langParam === this.language) && !alreadyConsumed) {
      this.videoFile = new File([captured], captured.name, { type: captured.type });
      this.videoType = 'external';
      this.changeStage('preview');
      const slug = sessionStorage.getItem(`share-your-story-slug-${this.language}`) || sessionStorage.getItem('share-your-story-slug');
      if (slug && slug !== 'null') {
        this.videoSlug = slug;
      }
      sessionStorage.setItem(`captured-consumed-${this.language}`, '1');
      return;
    }

    this.fetchData();
  },
};
</script>

<style lang="scss">
$md-max-width: 991px;

.share-story-container.content-page {
  padding: 0 !important;

  .share-story {
    padding: 20px;
    text-align: center;

    .ant-spin-spinning {
      max-height: initial;
    }
  }

  @media (max-width: $md-max-width) {
    .share-story {
      padding: 10px;
    }

    .ant-card-body {
      padding: 10px;
    }
  }

  .ant-card-extra {
    a {
      color: #fff !important;
    }
  }
  @media (min-width: 768px) {
    .ant-card-extra {
      position: absolute !important;
      right: 16px !important;
    }
  }
}
.share-story-container {
  .ant-card-extra {
    a {
      color: #fff !important;
    }
  }
}
.share-introvideo-title {
  .ant-card-head-title {
    font-size: 28px !important;
  }
}
</style>
<style lang="scss">
.text-warn {
  color: #ff0000;
}
#nprogress .spinner {
  display: none !important;
}

.dark-theme {
  .ant-layout {
    background-color: #454545;
    .ant-layout-content {
      .ant-card-body {
        background-color: #454545;
        color: white;
        a,
        h3,
        h5,
        label {
          color: white !important;
        }
        .content-item {
          .video-container {
            .player-wrapper {
              background: black;
            }
          }
          .tf-btn-primary,
          .ant-btn-primary {
            background: #ffb612 !important;
            border-color: #e7a510;
            color: white;
          }
          .share-wrapper {
            .st-first {
              background: #ffb612 !important;
              border-color: #e7a510;
              color: white;
              img {
                top: 8px;
              }
              .st-label {
                color: white !important;
              }
            }
            .st-last {
              background: #ffb612 !important;
              img {
                top: 8px;
              }
            }
          }
          h4 {
            color: white;
          }
        }
        .connect-to-church {
          .tf-text-primary {
            color: white !important;
          }
        }
        .ant-input-search {
          .ant-btn-primary {
            background: #ffb612 !important;
            border-color: #e7a510;
            color: white;
          }
        }
        .ant-table-wrapper {
          .ant-table-content {
            tbody.ant-table-tbody {
              .ant-table-row > td {
                border: none;
              }
              .ant-table-row-hover > td {
                background-color: #5e5e5e;
                a {
                  span:first-child {
                    color: white;
                    text-decoration: underline;
                  }
                }
              }
              .ant-table-row-cell-break-word {
                background-color: #454545;
              }
            }
          }
          .ant-pagination {
            .ant-pagination-item-link,
            .ant-pagination-item {
              background-color: #ffb612;
            }
          }
        }
      }
      .connect-to-church {
        .ant-card-body {
          div {
            span {
              color: white !important;
            }
          }
        }
      }
      .ant-spin-nested-loading {
        .ant-spin-dot-spin {
          .ant-spin-dot-item {
            background-color: white !important;
          }
        }
      }
    }
  }
  .ant-layout-footer {
    background-color: #454545;
    .index_footer_1JJNG {
      border-top: solid 1px #ffb612;
      .index_inner_3Cnfx {
        border: none;
      }
    }
  }
}
.ant-modal-root {
  .ant-modal-content {
    .ant-btn-primary {
      background-color: #ffb612;
      border-color: #ffb612;
    }
  }
}
</style>
